class Workers {
    public version: any = null;
}

export const workers = new Workers();
